// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Hyperlink__ifDesktop_Transition___Z0CU4 {
    text-shadow: none;
    transition: 0.2s;
}

.Hyperlink__actionOnlyButton___iGaUl {
    appearance: none;
}

:where(.Hyperlink__actionOnlyButton___iGaUl) {
    touch-action: manipulation;
    border: 0;
    margin: 0;
    padding: 0;
    background: transparent;
    color: inherit;
    font: inherit;
    text-align: inherit;
    cursor: pointer;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ifDesktop_Transition": `Hyperlink__ifDesktop_Transition___Z0CU4`,
	"actionOnlyButton": `Hyperlink__actionOnlyButton___iGaUl`
};
module.exports = ___CSS_LOADER_EXPORT___;
